import React from 'react';
import { Volume1 } from 'lucide-react';
import IntensitySlider from '../../ui/IntensitySlider';
import type { UnifiedOnboardingData } from '../../../lib/onboarding/unifiedTypes';

interface IntensityStepProps {
  data: UnifiedOnboardingData;
  onUpdate: (updates: Partial<UnifiedOnboardingData>) => void;
  onNext: () => void;
}

export default function IntensityStep({ data, onUpdate, onNext }: IntensityStepProps) {
  const handleIntensityChange = (value: number) => {
    onUpdate({ intensityLevel: value });
  };

  return (
    <div className="space-y-6">
      <div className="text-center">
        <Volume1 className="h-12 w-12 text-pink-400 hidden md:block mx-auto mb-4" />
        <h3 className="md:text-lg font-semibold text-gray-900 mb-2">
          Coaching Intensity
        </h3>
        <p className="md:text-base text-sm text-gray-600">
          How firm should your coach be with accountability?
        </p>
      </div>

      <IntensitySlider
        value={data.intensityLevel}
        onChange={handleIntensityChange}
      />
    </div>
  );
}